import React from 'react';
import { connect } from 'react-redux';

import { isAncor } from 'utils/version';
import { mapIndexed, notEmpty } from 'utils/ramdaAdditions';
import { openModalPerson } from 'actions/modalActions';
import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';

const PeopleList = ({ people, openModalPerson }) => (
    <div className="panel-view">
        <ul>
            { mapIndexed((item, index) => (
                <li key={index}>
                    { item.type === 'People' ? (
                        <a onClick={() => openModalPerson({ ...item, value: item.text })}>
                            { item.text }
                        </a>
                    ) : (
                        <span>
                            { item.text }
                        </span>
                    )}
                </li>
            ), people || []) }
        </ul>
    </div>
);

const ProjectParticipants = ({ project: { participants, clientcontactpers }, ...props }) => (
    <div>
        <DefinitionHeader translate="project.participants" iconType="user-group" />
        <PeopleList people={participants} {...props} />
        { isAncor() && notEmpty(clientcontactpers) && (
            <div>
                <DefinitionHeader translate="project.clientcontactpers" iconType="user-group" />
                <PeopleList people={clientcontactpers} {...props} />
            </div>
        )}
    </div>
);

export default connect(null, { openModalPerson })(ProjectParticipants);
